import { Images } from "lucide-react";
import { Link } from "react-router-dom";

const label = (n) => (n === 0 ? "Samples coming soon" : "Show me samples");

export const SampleLink = ({ product, testId, className = "" }) => (
  <Link
    to={`/samples/${product.id}`}
    state={{ fromBuilder: true }}
    data-testid={`${testId}-sample-link`}
    onClick={(e) => e.stopPropagation()}
    className={`flex flex-shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-[#1B66C9]/10 px-2.5 py-1 text-[11px] font-bold text-[#1B66C9] hover:bg-[#1B66C9] hover:text-white ${className}`}
  >
    <Images size={12} className="flex-shrink-0" /> {label(product.sample_count)}
  </Link>
);
